// THE PRODUCTION BUILD'S ONE ANSWER WHEN IT CANNOT START (B8, LAUNCH-COPY-B8).
//
// Every other build that cannot reach its server runs on the fake and says why in the console (`main.tsx`). The production
// build for app.proppeal.com never does: the fake is not in its bundle, and a customer shown made-up figures and a
// pretend checkout is the worst thing this page could do. So when it cannot start — Firebase would not sign the browser
// in or start App Check, or (impossible past the build's own refusal, `web/deployTargets.ts`, and handled anyway) the
// base URL is missing — it shows THIS: the logo and the token arm of `RefusalBody`, which is the sentence Tyler approved
// for exactly that moment (WEB-COPY-1 item 16, `transport.token`: "a sign-in or App Check token not obtained") under the
// heading every token failure already carries. No new words. `test/productionStartup.test.tsx` holds it.

import { BrandLockup } from "./BrandLockup";
import { RefusalBody } from "./Refusal";

export function StartupRefusal({ problem }: { problem: string }) {
  return (
    <main className="startup-refusal">
      <BrandLockup className="appbar-lockup" />
      <div className="refusal" data-refusal-kind="token" data-startup-refusal role="alert">
        <RefusalBody failure={{ ok: false, kind: "token", which: "idToken", problem }} />
      </div>
    </main>
  );
}
